import { render, staticRenderFns } from "./CreateCollection.vue?vue&type=template&id=0b65b562&"
import script from "./CreateCollection.vue?vue&type=script&lang=js&"
export * from "./CreateCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports